"use client";
import React, { useMemo } from "react";
import { cleanHeaderTags, createLookupObject } from "@/lib/helper";
import { ICMS } from "@/store/home/homeModel";
import { OptimizedImage } from "@/components/common/OptimizedImage";

interface PrivacyPolicyProps {
  cmsData: ICMS[];
  bannerData: any[];
}

const PrivacyPolicy: React.FC<PrivacyPolicyProps> = ({
  cmsData,
  bannerData,
}) => {
  const lookUpCMSData = useMemo(() => {
    return createLookupObject(cmsData || [], "Name");
  }, [cmsData]);

  const banner =
    bannerData?.filter(
      (banner: any) => banner?.BannerType === "privacy-policy",
    ) || [];

  return (
    <>
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden mt-24 bg-gradient-to-br from-[#1F3D2B] to-[#2A4F38]">
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60 z-10" />
        {banner?.length > 0 && banner[0]?.BannerImage && (
          <div className="absolute inset-0 z-0">
            <OptimizedImage
              src={banner[0]?.BannerImage}
              alt="Privacy Policy Banner"
              fill
              priority
              className="object-cover"
            />
          </div>
        )}
        <div className="relative z-20 text-center px-6">
          <h1 className="text-white mb-6 drop-shadow-2xl">Privacy Policy</h1>
        </div>
      </section>
      {lookUpCMSData["Privacy Policy"] && (
        <section className="py-20 bg-gradient-to-b from-white to-[#F3EBDD]/30 cms-section">
          <div
            className="max-w-7xl mx-auto px-6 lg:px-8"
            dangerouslySetInnerHTML={{
              __html: cleanHeaderTags(
                lookUpCMSData["Privacy Policy"]?.Template,
              ),
            }}
          />
        </section>
      )}
    </>
  );
};

export default PrivacyPolicy;
